// Treatments verified on nordicprolo.se and BokaDirekt (2026-09-28). Calm, factual rewrite – no efficacy claims.
export const treatments = [
  {
    id: "proloterapi",
    name: "Proloterapi",
    short: "Injektionsbehandling med dextros som används vid besvär i ledband, senor och leder.",
    what: "Vid proloterapi injiceras en lösning – vanligtvis med medicinsk dextros och ibland lokalbedövning – i det område där besvären sitter. Metoden används vid vissa besvär i ledband, senor och leder. Namnet kommer från ordet proliferation, som betyder tillväxt.",
    usedFor: [
      "Besvär kopplade till ledband, senor och leder",
      "Artros",
      "Ledbandsskador och instabilitet",
      "Överrörlighet, till exempel vid Ehlers-Danlos syndrom",
      "Idrottsskador",
      "Långvarig smärta efter skada, operation eller protes",
    ],
    visit: [
      "Bedömning av besvär, sjukdomshistoria och mål",
      "Området rengörs, lokalbedövning vid behov",
      "Läkaren ger injektionerna",
      "Du får råd om återhämtning och aktivitet",
    ],
    aftercare:
      "Efteråt kan lätt ömhet och svullnad förekomma. Flera behandlingstillfällen kan behövas, beroende på besvären och hur kroppen svarar.",
    locations: ["nacka", "goteborg"],
    sourceUrl: "https://nordicprolo.se/proloterapi/",
  },
  {
    id: "nervproloterapi",
    name: "Nervproloterapi",
    alt: "Perineural injektionsterapi",
    short: "Behandling av nervrelaterad smärta där en låg koncentration dextros ges runt ytliga nerver.",
    what: "Vid nervproloterapi injiceras en steril, lågkoncentrerad dextroslösning precis under huden, i området runt små ytliga nerver. Behandlingen riktar sig mot nervgrenar som inte syns på röntgen eller magnetkamera men som kan bidra till smärta.",
    usedFor: [
      "Nervrelaterad (neuropatisk) smärta",
      "Stickningar och domningar",
      "Nervsmärta vid diabetes",
    ],
    visit: [
      "Bedömning av symtom och tidigare utredningar",
      "Behandlingsområdet rengörs",
      "Injektioner precis under huden",
      "Uppföljning och eventuell fortsatt serie",
    ],
    aftercare:
      "Enligt kliniken ges nervproloterapi vanligtvis som en serie om fyra till sex behandlingar under några veckor. Upplägget bestäms individuellt.",
    locations: ["nacka", "goteborg"],
    sourceUrl: "https://nordicprolo.se/nervproloterapi/",
  },
  {
    id: "prp",
    name: "PRP",
    alt: "Platelet-Rich Plasma",
    short: "Behandling med din egen blodplasma, koncentrerad på blodplättar och tillväxtfaktorer.",
    what: "Vid PRP-behandling tas ett blodprov som centrifugeras så att plasma rik på blodplättar och tillväxtfaktorer kan koncentreras. Plasman injiceras sedan i det område som behandlas.",
    usedFor: ["Led-, sen- och muskelbesvär", "Artros", "Långvarig smärta", "Idrottsskador"],
    visit: [
      "Läkarbedömning av om PRP är lämpligt",
      "Blodprov tas och bearbetas på plats",
      "Plasman injiceras i området",
    ],
    aftercare: "Hur många behandlingar som är aktuella avgörs vid läkarbesöket.",
    locations: ["nacka"],
    sourceUrl: "https://www.bokadirekt.se/places/nordic-prolo-smartklinik-59314",
  },
  {
    id: "mls-laser",
    name: "MLS-laser",
    alt: "Multiwave Locked System",
    short: "Medicinsk laserbehandling som utförs av läkare, fristående eller tillsammans med andra behandlingar.",
    what: "MLS-laser är en medicinsk laserbehandling som hos Nordic Prolo alltid utförs av läkare. Den kan ges som fristående behandling eller kombineras med exempelvis proloterapi och PRP. Den kan bokas som engångsbehandling eller som paket om 12 tillfällen.",
    usedFor: [
      "Långvarig ledsmärta, till exempel vid artros",
      "Nervsmärta",
      "Muskelsmärta, stelhet och spänningar",
      "Återkommande idrottsskador",
      "Återhämtning efter kirurgi",
      "Instabilitet i övre nacken (CCI/AAI)",
    ],
    visit: ["Kort genomgång av besvären", "Laserbehandling av området", "Plan för eventuella fler tillfällen"],
    aftercare: "Antal tillfällen anpassas efter besvären.",
    locations: ["nacka"],
    sourceUrl: "https://www.bokadirekt.se/places/nordic-prolo-smartklinik-59314",
  },
  {
    id: "neuropatiutredning",
    name: "Neuropatiutredning, B12 och SUDOSCAN",
    short: "Utredning vid stickningar, domningar eller brännande känsla i händer och fötter.",
    what: "Utredningen hjälper dig att förstå möjliga orsaker till nervsymtom. Den omfattar en bred laboratoriebedömning med totalt 37 markörer, bland annat B12- och näringsstatus, blodsocker, sköldkörtel-, lever- och njurfunktion. Här ingår även SUDOSCAN – en smärtfri undersökning utan nålar som mäter funktionen i små nervfibrer och svettkörtlar i händer och fötter.",
    usedFor: [
      "Stickningar och domningar",
      "Brännande känsla i händer eller fötter",
      "Misstänkt eller konstaterad B12-brist",
      "Misstanke om småfiberneuropati eller polyneuropati",
    ],
    visit: [
      "Blodprover och SUDOSCAN på kliniken",
      "Genomgång av provsvar och anamnes med läkare",
      "Individuell behandlingsplan, B12-injektioner vid medicinsk indikation",
      "Uppföljande telefonsamtal efter tre månader",
    ],
    aftercare:
      "SUDOSCAN bör inte användas vid pacemaker, ICD, hudskador eller metallimplantat i händer eller fötter samt vid kraftig svullnad. SUDOSCAN kan även bokas separat i Nacka.",
    locations: ["nacka", "goteborg"],
    sourceUrl: "https://www.bokadirekt.se/places/nordic-prolo-smartklinik-59314",
  },
];

export const getTreatment = (id) => treatments.find((t) => t.id === id);

export const processSteps = [
  { title: "Bedömning", text: "Genomgång av sjukdomshistoria, läkemedel, tidigare skador och dina mål. Smärtområdet undersöks och en plan läggs upp." },
  { title: "Förberedelse", text: "Behandlingsområdet rengörs noggrant. Lokalbedövning kan användas vid behov." },
  { title: "Behandling", text: "Läkaren ger behandlingen, till exempel injektioner med en dextrosbaserad lösning." },
  { title: "Eftervård", text: "Lätt ömhet och svullnad kan förekomma. Du får tydliga råd om återhämtning och aktivitet." },
  { title: "Uppföljning", text: "Resultatet följs upp. Flera behandlingstillfällen kan behövas beroende på besvären." },
];

export const firstVisit = {
  title: "Ditt första besök",
  points: [
    "Nybesöket tar cirka 60 minuter.",
    "Vi går igenom sjukdomshistoria, symtom och tidigare behandlingar.",
    "Läkaren undersöker dig och bedömer om behandling är lämplig.",
    "Du får en förklaring av behandlingen och en individuell plan.",
  ],
  extras: [
    "Vill du hellre börja på distans kan du boka en distanskonsultation via video eller telefon.",
    "Det går även att boka nybesök och behandling vid samma tillfälle.",
  ],
};
